export const profileKeys = {
  profile: () => ['profile'],
} as const;
